// The Location line under a kiosk card (Show Card Locations).
//
// The server sends each place as one string: a bin ("CASE 4"), or with a Show /
// Vendor Transfer slot, "Purple Binder 2, Page 4, Slot 3" (TKT-2026-107463,
// backend/utils/kioskCardLocations.js). Joined with ", " two slotted places run
// together, so a list holding a comma is joined with "; " instead. A list of plain
// bins reads exactly as it always has.
export function joinLocations(locations) {
  const list = Array.isArray(locations) ? locations.filter((l) => typeof l === 'string' && l) : [];
  return list.join(list.some((l) => l.includes(',')) ? '; ' : ', ');
}

export default joinLocations;
